import React, { useEffect, useState } from 'react'
import "./PointHistory.css"
import { GetPointsHistory } from '../../Api/commonAPI';
import { decryptData } from "../../common/encryptAnddecryptData";
import { formatCustomDate } from '../../common/common';

const PointHistory = ({ token, userDetails, setIsPointHistory }) => {

    const [points, setPoints] = useState([]);
    
    const [loading, setLoading] = useState(true);

    const fetchPointHistory = async () => {
        try {
            const response = await GetPointsHistory(userDetails, token);
            const data = response.data;
            const decrypted = decryptData(data?.data);
            let AllPoints = decrypted?.PointsHistory.sort((a, b) => new Date(b.CreatedDate) - new Date(a.CreatedDate));
            setPoints(AllPoints);
            setLoading(false);
        } catch (error) {
            console.error("Points fetch error:", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPointHistory();
    }, []);

    return (
        <>
            {!loading && (
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
                >
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content" style={{ maxHeight: '80vh' }}>
                            <div className="modal-header">
                                <h5 className="modal-title">Point History</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setIsPointHistory(false)}
                                ></button>
                            </div>

                            <div className="modal-body overflow-auto" style={{ maxHeight: '60vh' }}>
                                {points?.length > 0 ? (
                                    points.map((item, index) => (
                                        <div
                                            key={index}
                                            className="mb-4 p-3 border rounded shadow-sm bg-light"
                                        >
                                            <div className="row mb-2">
                                                <div className="col-6 fw-bold">Date:</div>
                                                <div className="col-6">{formatCustomDate(item?.CreatedDate)}</div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-6 fw-bold">Transaction Type:</div>
                                                <div className="col-6">{item?.TransactionTypeName}</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-6 fw-bold">Points:</div>
                                                <div
                                                    className="col-6"
                                                    style={{ color: (item?.TransactionTypeID === 2 || item?.TransactionTypeID === 5) ? 'red' : 'green' }}
                                                >
                                                    {item?.AddOrUpdatePoints}
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p className="m-0">No point history available.</p>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button onClick={() => setIsPointHistory(false)} className="close-warning-button">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default PointHistory
